// @ts-nocheck
import { useState } from 'react';
import styled from 'styled-components';
import { useLoaderData, useNavigate } from 'react-router-dom';
import MainContainer from '../../ui_components/MainContainer';
import { LoadingState } from '../../stats_components/LoadingState';
import BoxListMatchMobileComponent from './SingleSpecificPpv/BoxListMatchMobileComponent';
import colors from '../../../styles/colors';

const TopBasicInfoPpv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & .name-ppv {
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        margin: 0;
        padding: 0;
    }

    & .date-ppv {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        margin: 0;
        padding: 0;
    }

    & .arena-ppv {
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`;

const BoxLinkNightsPpv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    row-gap: 5px;
`

const ButtonNightPpv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px;
    border: 1px solid white;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: white;
    background-color: ${colors.bgColorBlack2};
    min-width: 120px;
    font-size: 12px;

    &:hover {
        background-color: white;
        color: ${colors.bgColorBlack2};
    }
`

const BoxAvatar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    & img.box-avatar-image {
        width: 40%;
        max-height: 300px;
        object-fit: cover;
        object-position: top;
        border: 1px solid white;
    }
`;

const SingleSpecificPpvMobile = () => {
    const [responseData, setResponseData] = useState(useLoaderData());
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    function navigateGoToArenaPage(arena) {
        let url = '/arenas/' + arena.id;
        navigate(url);
    }

    function navigateGoToNightPpv(nightUrl) {
        // navigazione presso pagina esterna (si apre nuova scheda)
        window.open(nightUrl, '_blank');
    }

    // In loading
    if(isLoading) {
        return <LoadingState />;
    }

    return (
        <MainContainer isMobile={true}>
            <TopBasicInfoPpv className='top-basic-info-ppv'>

                {/* Nome PPV  */}
                <h1 className='name-ppv'>{responseData.ppv_description.name}</h1>

                {/* Data PPV  */}
                <h6 className='date-ppv'>{responseData.date}</h6>

                {/* Arena PPV  */}
                {responseData.arena && (
                    <h5 
                     onClick={() => navigateGoToArenaPage(responseData.arena)}
                     className='arena-ppv'
                    >{responseData.arena.name}</h5>
                )}

                    <BoxLinkNightsPpv className="box-link-nights-ppv">
                        {responseData.night1 && (
                            <ButtonNightPpv onClick={() => navigateGoToNightPpv(responseData.night1)}>Night 1</ButtonNightPpv>
                        )}
                        {responseData.night2 && (
                            <ButtonNightPpv onClick={() => navigateGoToNightPpv(responseData.night2)}>Night 2</ButtonNightPpv>
                        )}
                        {responseData.night3 && (
                            <ButtonNightPpv onClick={() => navigateGoToNightPpv(responseData.night3)}>Night 3</ButtonNightPpv>
                        )}

                        {(!responseData.night1 && !responseData.night2 && !responseData.night3) && (
                            <div className="btn-no-night">Nessun link disponibile</div>
                        )}
                    </BoxLinkNightsPpv>

                {/* Avatar  */}
                <BoxAvatar className='box-avatar'>
                    <img 
                     className='box-avatar-image' 
                     src={process.env.REACT_APP_STORAGE_URL + responseData.img_path} 
                     alt={responseData.ppv_description.name} 
                     title={responseData.ppv_description.name}
                    />
                </BoxAvatar>

                {/* Lista Match  */}
                <BoxListMatchMobileComponent listMatch={responseData.fights} />
            </TopBasicInfoPpv>
        </MainContainer>
    )
}

export default SingleSpecificPpvMobile;